import { useState } from "react";

import { Alert, AlertTitle, Collapse, IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import { RUNTIME_CONFIG_MISCONFIGURED } from "src/handlers/Appwrite";

/**
 * Shows a dismissable warning banner when the app is running with a
 * runtime-config script that exists but is empty — i.e. a self-host deploy
 * that forgot to set `APPWRITE_ENDPOINT` / `APPWRITE_PROJECT_ID`.
 */
function ConfigBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (!RUNTIME_CONFIG_MISCONFIGURED) return null;

  return (
    <Collapse in={!dismissed}>
      <Alert
        severity="warning"
        variant="filled"
        sx={{
          borderRadius: 0,
          alignItems: "flex-start"
        }}
        action={
          <IconButton
            aria-label="Dismiss configuration warning"
            color="inherit"
            size="small"
            onClick={() => setDismissed(true)}
          >
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        }
      >
        <AlertTitle sx={{ fontWeight: 700 }}>NetBase runtime config is missing</AlertTitle>
        The app is falling back to the hosted NetBase API because{" "}
        <code>APPWRITE_ENDPOINT</code> and <code>APPWRITE_PROJECT_ID</code> are empty. If you are
        self-hosting, set these environment variables on your container and restart.
      </Alert>
    </Collapse>
  );
}

export default ConfigBanner;
